import { coverSrc, itemDataUrl, itemPhotoSrc, shopDataUrl, shopItemsUrl, shopLogoUrl, shopPageQuery } from "../public-shop-view.js";
import { AppError } from "./errors.js";
/** The web's report of one of the profile's reviews, through the Worker, behind Turnstile (P3 Enmienda 4). */
export function publicReviewReportPath(slug, reviewId) {
    return `${shopDataUrl(slug)}/reviews/${reviewId}/report`;
}
/** What a stranger is told when the profile or the item is not there: unpublished, in its sample, or never was. */
export const PROFILE_GONE_MESSAGE = "Este perfil no está disponible.";
const ITEM_GONE_MESSAGE = "Este enlace ya no está activo.";
const LOAD_FAILED_MESSAGE = "No pudimos cargar esto.";
export function publicShopReader(origin, fetchFn) {
    const base = origin.replace(/\/+$/, "");
    const get = async (path, gone) => {
        const response = await fetchFn(`${base}${path}`);
        // A 404 is the one answer no retry changes; a limit or an outage may heal.
        if (response.status === 404)
            throw new AppError(gone, undefined, { retryable: false });
        if (!response.ok)
            throw new AppError(LOAD_FAILED_MESSAGE, response.status);
        return (await response.json());
    };
    return {
        shop: (slug) => get(shopDataUrl(slug), PROFILE_GONE_MESSAGE),
        cards: async (slug, query, cursor) => {
            const q = query.q ?? "";
            const section = query.section ?? null;
            const page = await get(shopItemsUrl(slug, cursor ?? null, q, section, query.kind), PROFILE_GONE_MESSAGE);
            const listedBy = shopPageQuery(cursor ?? null, q, section, query.kind);
            return {
                ...page,
                items: page.items.map((item) => {
                    const cover = coverSrc(slug, item, listedBy);
                    return { item, cover: cover === null ? null : `${base}${cover}` };
                }),
            };
        },
        logoUrl: (slug) => `${base}${shopLogoUrl(slug)}`,
        coverUrl: (shop) => (shop.profile.cover === null ? null : `${base}${shop.profile.cover}`),
        item: (token) => get(itemDataUrl(token), ITEM_GONE_MESSAGE),
        reviews: (slug, cursor) => get(`${shopDataUrl(slug)}/reviews${cursor === null ? "" : `?cursor=${encodeURIComponent(cursor)}`}`, PROFILE_GONE_MESSAGE),
        itemPhotoUrl: (token, attachmentId, size) => `${base}${itemPhotoSrc(token, attachmentId, size)}`,
    };
}
